import cookies from 'react-cookies';
export { IN_STOCK_STATUS_TYPES, isInStockStatus, getIsInStock } from './stock';
export { isMobileNavigator } from './isMobileNavigator';
export { setupMobileViewport, MOBILE_VIEWPORT_CONTENT } from './setupMobileViewport';
const supportLangs = ['vi', 'en', 'zh', 'hu', 'th', 'ms', 'pt-BR', 'zh_Hant', 'id', 'ru', 'de'];

// 检查元素是否在某个元素里，与 jQuery.contains 等同
export function contains(container, target) {
  if (target) {
    while ((target = target.parentNode)) {
      if (container === target) {
        return true;
      }
    }
  }
  return false;
}

// 获取元素到页面左边与顶部的距离，与 jQuery().offset() 结果等同
export function offset(elem) {
  const offset = { left: 0, top: 0 };
  while (elem) {
    offset.left += elem.offsetLeft;
    offset.top += elem.offsetTop;
    elem = elem.offsetParent;
  }
  return offset;
}

export function isWindow(elem) {
  return elem != null && elem === elem.window;
}

export function getClientHeight(elem) {
  if (isWindow(elem) || elem.nodeType === 9) {
    elem = document.documentElement;
  }
  return elem.clientHeight;
}

export function getScrollHeight(elem) {
  if (isWindow(elem) || elem.nodeType === 9) {
    elem = document.documentElement;
  }
  return elem.scrollHeight;
}

export function scrollTop(elem, value) {
  let win;
  if (isWindow(elem)) {
    win = elem;
  } else if (elem.nodeType === 9) {
    win = elem.defaultView;
  }

  if (value === undefined) {
    return win ? win.pageYOffset : elem.scrollTop;
  }

  if (win) {
    win.scrollTo(0, value);
  } else {
    elem.scrollTop = value;
  }
}

export function scrollTo(to, element = window, speed = 0.3) {
  // to 不能小于 0，不能大于最大滚动距离
  to = Math.max(0, Math.min(getScrollHeight(element) - getClientHeight(element), to));

  clearInterval(element.TIMER_OF_SRCOLL_TO);
  element.TIMER_OF_SRCOLL_TO = setInterval(function() {
    let st = scrollTop(element);
    const position = (to - st) * speed;

    st += st > to ? Math.floor(position) : Math.ceil(position);

    scrollTop(element, st);

    if (st < to + 1 && st > to - 1) {
      clearInterval(element.TIMER_OF_SRCOLL_TO);
      scrollTop(element, to);
    }
  }, 30);
}

export function uniqByArray(target, filterArray, iteratee) {
  if (!Array.isArray(target) || !Array.isArray(filterArray)) {
    return [];
  }

  if (!filterArray.length) {
    return target;
  }

  if (!iteratee || typeof iteratee !== 'string') {
    throw new Error('[uniqByArray]: The third parameter is required and must be a string.');
  }

  return target.filter(item => {
    let result = true;
    const value = item[iteratee];
    filterArray.some(arr => {
      if (arr[iteratee] === value) {
        result = false;
        return true;
      }
    });
    return result;
  });
}

//获取url参数
export function getUrlsQuery(name, url = window.location.search) {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
  const r = url.substr(1)?.match(reg);
  if (r != null) return decodeURIComponent(r[2]);
  return null;
}

export function getPrice(price) {
  if (!price) {
    return {
      int: '0',
      float: '00',
    };
  }
  const arr = typeof price === 'number' ? String(price.toFixed(2)).split('.') : price.split('.');
  const int = arr[0] || '0';
  const float = arr[1] || '00';
  return {
    int,
    float,
  };
}

// 仅对整数部分加千分位；整串 replace 会在 4 位及以上小数中误插入逗号（如 82.3500 → 82.3,500）
function addThousandsSeparator(formattedMoney) {
  const [integerPart, decimalPart] = String(formattedMoney).split('.');
  const withCommas = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return decimalPart !== undefined ? `${withCommas}.${decimalPart}` : withCommas;
}

export function formatMoney(money, showCurrency = true) {
  if (money === null || money === undefined) {
    return money
  }
  const moneyStr = String(money);
  const decimalIndex = moneyStr.indexOf('.');
  let floatNum = decimalIndex === -1 ? 0 : moneyStr.length - decimalIndex - 1;

  // 先将数字格式化为指定小数位数
  let formattedMoney = Number(moneyStr).toFixed(floatNum);
  formattedMoney = addThousandsSeparator(formattedMoney);
  
  return (showCurrency ? '$' : '') + formattedMoney;
}

// decimalPlaces：指定小数位（如运费/税金固定 2 位）；不传则保留入参原有小数位
export function cnyMoney(money, showCurrency = true, symbol, decimalPlaces) {
  if (money === null || money === undefined) {
    return money
  }

  // 兜底精度：浮点运算误差（如 600 - 539.67 = 60.330000000000004）或过长小数时，
  // 在未被 TLT/语言包进一步格式化之前先截断为 2 位，避免页面原样透出长小数。
  // 若上游已显式传入 decimalPlaces，优先用传入值。
  let moneyNum = Number(money);
  let moneyStr = String(money);
  if (decimalPlaces == null && typeof moneyNum === 'number' && isFinite(moneyNum)) {
    // 对非整数金额统一保留 2 位小数（金额业务场景下不应超过 2 位分）
    if (!Number.isInteger(moneyNum)) {
      moneyNum = Math.round(moneyNum * 100) / 100;
      moneyStr = String(moneyNum);
    }
  }

  const decimalIndex = moneyStr.indexOf('.');
  let floatNum =
    decimalPlaces != null
      ? decimalPlaces
      : decimalIndex === -1
        ? 0
        : moneyStr.length - decimalIndex - 1;

  // 先将数字格式化为指定小数位数
  let formattedMoney = Number(moneyStr).toFixed(floatNum);
  formattedMoney = addThousandsSeparator(formattedMoney);

  return (showCurrency ? symbol || '¥' : '') + formattedMoney;
}

/**
 * 获取页面url参数
 */
export function GetRequest() {
  const url = location.search;
  const theRequest = new Object();
  if (url.indexOf('?') != -1) {
    const str = url.substr(1);
    const strs = str.split('&');
    for (let i = 0; i < strs.length; i++) {
      theRequest[strs[i].split('=')[0]] = decodeURIComponent(strs[i].split('=')[1]);
    }
  }
  return theRequest;
}
export function getUrlParams(name, str) {
  const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
  if (str.indexOf('?') === -1) return null;
  const r = str.substr(1)?.match(reg);
  if (r != null) {
    return decodeURIComponent(r[2]);
  }
  return null;
}

/**
 * 判断参数是否为空
 * @param param
 */
export function isEmpty(param) {
  const nullArr = ['', null, undefined];
  if (nullArr.includes(param)) {
    return true;
  }
  return false;
}

/**
 * 过滤参数
 * @param params 需要被过滤的对象
 */
export function filterParams(params) {
  const newVlaue = {};
  // eslint-disable-next-line no-undef
  Reflect.ownKeys(params).forEach(attr => {
    if (!isEmpty(params[attr])) {
      if (typeof params[attr] === 'string') {
        newVlaue[attr] = params[attr].trim();
      } else {
        newVlaue[attr] = params[attr];
      }
    }
  });
  return newVlaue;
}

export function goTop(animated = true) {
  window.scrollTo({
    top: 0,
    behavior: animated ? 'smooth' : 'auto',
  });
}

export function duration(timestamp) {
  const oneMinute = 60;
  const oneHour = 60 * oneMinute;
  const oneDay = 24 * oneHour;
  const days = Math.floor(timestamp / oneDay);
  let remain = timestamp - days * oneDay;
  const hours = Math.floor(remain / oneHour);
  remain = timestamp - days * oneDay - hours * oneHour;
  const minutes = Math.floor(remain / oneMinute);
  if (days > 0) {
    return `${days}天${hours}时`;
  } else {
    return `${hours}时${minutes}分`;
  }
}
export function getClstag(id, typeName) {
  return `h|keycount|${typeName}|${id}`;
}
export function getCookie(name) {
  const arr = document.cookie?.match(new RegExp(`(^| )${name}=([^;]*)(;|$)`));
  if (arr != null) {
    return arr[2];
  }
  return '';
}

export function initArea(areaId = 'jdarea') {
  setTimeout(() => {
    // @ts-ignore
    // eslint-disable-next-line no-undef
    $(`#${areaId}`).area({
      scopeLevel: 4,
      hasCssLink: false,
      cookieMapping: { allLocal: 'new_isp_address' },
      // @ts-ignore
      // eslint-disable-next-line no-undef
      initArea: readCookie('new_isp_address') || '1_72_2819_0.123',
      cookieOpts: { path: '/', domain: 'jd.com', expires: 30 },
      onChange: function() {
        location.reload();
      },
    });
  }, 1000);
}

//判断是否是IE浏览器 && 是否是IE11浏览器
export function isIE() {
  const userAgent = navigator.userAgent;
  return userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1;
}
export const getQueryVariable = (variable: string) => {
  const query = window.location.search.substring(1);
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split('=');
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return false;
};
export const insertParam = (key: string, value: string) => {
  key = decodeURIComponent(key);
  value = decodeURIComponent(value);

  const kvp: any = document.location.search.substr(1).split('&');
  if (kvp == '') {
    document.location.search = '?' + key + '=' + value;
  } else {
    let i = kvp.length;
    let x;
    while (i--) {
      x = kvp[i].split('=');

      if (x[0] == key) {
        x[1] = value;
        kvp[i] = x.join('=');
        break;
      }
    }
    //如果不是设置分页，初始化为第一页
    if (key != 'pageNo') {
      let i = kvp.length;
      let x;
      while (i--) {
        x = kvp[i].split('=');

        if (x[0] == 'pageNo') {
          x[1] = 1;
          kvp[i] = x.join('=');
          break;
        }
      }
    }

    if (i < 0) {
      kvp[kvp.length] = [key, value].join('=');
    }

    //this will reload the page, it's likely better to store this until finished
    // document.location.search = kvp.join("&");
  }
  let i = kvp.length;
  let x;
  let newUrl = '';
  while (i--) {
    x = kvp[i].split('=');

    if (x[1] == '') {
      x[1] = value;
      kvp.splice(i, 1);
      break;
    }
  }
  newUrl = kvp.length > 0 ? '?' + kvp.join('&') : '';
  const { origin, pathname } = window.location;
  if (key == 'priceFilter') {
    window.location.href = origin + pathname + newUrl;
  } else {
    window.history.pushState({}, '', origin + pathname + newUrl);
  }
};
//设置整个paramFilter2参数
export const insertParam2 = (key: string, value: string) => {
  key = decodeURIComponent(key);
  value = decodeURIComponent(value);
  const arrkey = getQueryVariable(`extAttrList`) ? decodeURIComponent(getQueryVariable(`extAttrList`)).split(',') : [];
  const isU = arrkey.find(arrkey => arrkey.split('|')[0] == value.split('|')[0]);
  const isOneV = arrkey.find(arrkey => arrkey.split('|')[0] == value);
  if (key == 'extAttrList' && arrkey.length > 0) {
    if (!isU) {
      arrkey.push(value);
    } else {
      arrkey.splice(
        arrkey.findIndex(e => e.split('|')[0] == value.split('|')[0]),
        1,
      );
      arrkey.push(value);
    }
    value = arrkey;
  }

  if (key == 'extAttrList' && arrkey.length > 0 && isOneV) {
    arrkey.splice(
      arrkey.findIndex(e => e.split('|')[0] == value),
      1,
    );
    value = arrkey;
  }

  const kvp: any = document.location.search.substr(1).split('&');

  if (kvp == '') {
    document.location.search = '?' + key + '=' + value;
  } else {
    let i = kvp.length;
    let x;
    while (i--) {
      x = kvp[i].split('=');
      //找到pageNo，初始化为第一页
      if (x[0] == 'pageNo') {
        x[1] = 1;
        kvp[i] = x.join('=');
      }

      if (x[0] == key) {
        // x[1] = encodeURIComponent(value);
        x[1] = value;
        kvp[i] = x.join('=');
        break;
      }
    }

    if (i < 0) {
      kvp[kvp.length] = [key, encodeURIComponent(value)].join('=');
    }

    //this will reload the page, it's likely better to store this until finished
    // document.location.search = kvp.join("&");
  }
  let i = kvp.length;
  let x;
  let newUrl = '';
  while (i--) {
    x = kvp[i].split('=');
    if (x[1] == '') {
      x[1] = value;
      kvp.splice(i, 1);
      break;
    }
  }

  newUrl = kvp.length > 0 ? '?' + kvp.join('&') : '';

  // const { origin, pathname } = window.location;
  // window.location.href = origin + pathname + newUrl;
  const { origin, pathname } = window.location;
  if (kvp.length == 0) {
    window.location.href = origin + pathname;
  } else {
    window.history.pushState({}, '', origin + pathname + newUrl);
  }
};

//获取pvid
export const getPvId = () => {
  let d = new Date().getTime();
  const uuid = 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
  return uuid;
};
//获取uuid

export const getUuid = () => {
  const uuidStr = cookies.load('__jda') || null;
  const uuids = uuidStr?.split('.');
  return uuids?.length > 1 ? uuids[1] : '';
};
// 搜索词高亮替换
export const replaceString = (parentStr, searchText) => {
  const regSearchText = searchText.replace(
    /[[\]{};',./:"<>?!@#$%^&*()_+【】、；‘，。、{}|："“《》？！@#￥%……&*（）——+]*/g,
    '',
  ); //过滤特殊字符
  if (regSearchText) {
    const res = new RegExp('(' + regSearchText + ')', 'g');
    parentStr = parentStr?.replace(res, "<span style='color:#e50c00;'>" + regSearchText + '</span>');
    return parentStr;
  } else {
    return parentStr;
  }
};

// 递归扁平化publicPromise权限列表
export const flattenPublicPromise = (pp = []) => {
  const _arr = [];
  const loop = (oobj, narr) => {
    if (oobj.children) {
      narr.push(...oobj.children);
      oobj.children.forEach(e => {
        loop(e, narr);
      });
    }
    return narr;
  };

  pp &&
    pp.forEach(e => {
      loop(e, _arr);
    });

  return _arr;
};

export const getValues = (values: any) => {
  const newValues: any = [];
  values &&
    values?.forEach((item: any) => {
      for (const key in item) {
        newValues.push({
          key: key,
          value: item[key],
        });
      }
    });
  return newValues;
};


export function getJdiOSFile (path) {
  return `https://jdios.jdindustry.com/${path}`
}

function getBaseLanguage() {
  const language = navigator.language;
  const locale = new Intl.Locale(language);
  return locale.language;
}

export function formatLanguage() {
  const currentSelectLangCode = localStorage.getItem('_language'); //上次设置语言
  const browserDefaultLang = getBaseLanguage();

  const langCode =
    currentSelectLangCode || (supportLangs.includes(browserDefaultLang) && browserDefaultLang) || 'zh';

  return langCode?.replace('-', '_');
}
